import Modal from 'react-modal';
import PropTypes from 'prop-types';
import "../../../styles/AdminPage.css";
import React , {useEffect, useState} from 'react';
import { createGender, updateGender } from '../../../api/admin/AdminSettingsAPI';
import AdminSettingsEditModal from './AdminSettingsEditModal';
import DropdownModalContent from './EditDropdownModal';
import toast from 'react-hot-toast';

Modal.setAppElement('#root');

const EditGenderModal = ({ isOpen, onClose, isAdding, item, setItems }) => {    
    const [dropdownValue, setDropdownValue] = useState("");
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (!isAdding && item) {
            setDropdownValue(item.dropdownValue);
            setPosition(item.position);
        }
    }, [isAdding, item]);

    const modalTitle = isAdding ? "Add Gender" : "Edit Gender";

    const handleConfirm = async () => {
        let data;

        if (isAdding) {
            data = {
                dropdownValue,
                position
            };

            try {
                toast.loading("Creating Gender...");
                const response = await createGender(data);
                setTimeout(async () => {
                    if (response.ok) {
                        toast.dismiss();
                        try {
                            const newData = await response.json();
                            toast.success("Gender created!");
                            setItems((prev) => [...(prev ?? []), newData]);
                            onClose();
                        } catch (jsonError) {
                            console.error("Error parsing JSON:", jsonError);
                            toast.error("Error parsing server response.");
                        }
                    } else {
                        toast.dismiss();
                        console.log("Error creating Gender. Status:", response.status);
                        toast.error("Gender failed to create. Status: " + response.status);
                    }
                    
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Gender:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }
        } else {
            data = {
                id: item.id,
                dropdownValue: dropdownValue,
                position: position
            };
            try {
                toast.loading("Updaing Gender...");
                const response = await updateGender(data);
                setTimeout(async () => {
                        if (response.ok) {
                            toast.dismiss();
                            try {
                                toast.success("Gender updated!");
                                setItems((prev) => (prev ?? []).map(g => g.id === item.id ? data : g));
                                onClose();
                            } catch (jsonError) {
                                console.error("Error parsing JSON:", jsonError);
                                toast.error("Error parsing server response.");
                            }
                        } else {
                            toast.dismiss();
                            console.log("Error updating Gender. Status:", response.status);
                            toast.error("Gender failed to create. Status: " + response.status);
                        }
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Gender:", error);
                alert("Something went wrong. Please check your connection and try again.");
            }
        }
    };

    const content = (
        <DropdownModalContent 
            dropdownValue={dropdownValue}
            setDropdownValue={setDropdownValue}
            position={position}
            setPosition={setPosition}
        />
    )

    return (
        <AdminSettingsEditModal
            modalTitle={modalTitle}
            content={content}
            isOpen={isOpen}
            onClose={onClose}
            handleConfirm={handleConfirm}
        />
    );
};

EditGenderModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EditGenderModal;